import type { AtlasResponse, ConfigResponse, PublicDilemma, SubmitResponse } from '../types';

async function parseJson<T>(res: Response): Promise<T> {
  const data: any = await res.json().catch(() => null);
  if (!res.ok || !data?.ok) {
    throw new Error(data?.error || `Request failed (${res.status})`);
  }
  return data as T;
}

export async function getConfig(): Promise<ConfigResponse> {
  return parseJson<ConfigResponse>(await fetch('/api/config'));
}

export async function getDilemma(exclude: string[] = []): Promise<PublicDilemma> {
  const params = new URLSearchParams();
  for (const id of exclude.slice(-12)) params.append('exclude', id);
  const res = await parseJson<{ ok: true; dilemma: PublicDilemma }>(await fetch(`/api/dilemma?${params.toString()}`));
  return res.dilemma;
}

export async function getAtlas(): Promise<AtlasResponse> {
  return parseJson<AtlasResponse>(await fetch('/api/atlas'));
}

export async function submitUncertainty(payload: unknown): Promise<SubmitResponse> {
  return parseJson<SubmitResponse>(await fetch('/api/respond', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload)
  }));
}
